// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"afd7d1e4","487":"18ccb7c9","554":"af3e0c1d","599":"f9760d0f","841":"abf2fa63"}[chunkId] + ".chunk.css";
};